module.exports = __webpack_public_path__ + "static/img/join_pic_02.e595c45.e595c45.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/join_pic_02.e595c45.png
// module id = hkxH
// module chunks = 1